module.exports = __webpack_public_path__ + "media/images/favicon-ce0d3a3e835ffff5688ae746f6987a81.png";